import { GetAccountUserListParameterType } from '../types/options';
import { AccountUserApiV2 } from '../../../../../../lib/api/account/user/AccountUserApiV2';
import { AccountUserListResponseType } from '../types/accountUser';

export interface IAccountUserListRepository {
  getAccountUserList(options: GetAccountUserListParameterType): Promise<AccountUserListResponseType>;
}
export const AccountUserListRepository: IAccountUserListRepository = {
  getAccountUserList: (options: GetAccountUserListParameterType): Promise<AccountUserListResponseType> =>
    AccountUserApiV2.getAccountUserList(options),
};
